/**
 * Converts a base64 string to a data URL.
 * @param base64 - The base64 string to convert.
 * @param mediaType - The media type of the data URL. Default is "image/png".
 * @returns The converted data URL.
 */
interface ConvertBase64Props {
  base64: string | null | undefined
  mediaType?: string | null | undefined
}
export function convertImgBase64({
  base64,
  mediaType = "png",
}: ConvertBase64Props) {
  return base64 ? `data:image/${mediaType};base64,${base64}` : undefined
}
